import React from 'react';
import { FiX, FiGlobe, FiRotateCcw } from 'react-icons/fi';

const ChatHeader = ({ language, toggleLanguage, onClose, onReset }) => {
    return (
        <div className="bg-gradient-to-r from-cherry-800 to-cherry-600 p-4 rounded-t-2xl shadow-lg flex items-center justify-between z-10 relative overflow-hidden">
            {/* Decorative Background */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none"></div>

            <div className="flex items-center gap-3 relative z-10">
                <div className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/20 shadow-inner">
                    <span className="text-xl">🤖</span>
                </div>
                <div>
                    <h3 className="text-white font-bold font-playfair tracking-wide">Worker Support</h3>
                    <div className="flex items-center gap-1.5">
                        <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                        <p className="text-cherry-100 text-xs font-medium">Online • {language === 'en' ? 'English' : 'தமிழ்'}</p>
                    </div>
                </div>
            </div>

            <div className="flex items-center gap-1 relative z-10">
                <button
                    onClick={onReset}
                    className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-all"
                    title="Reset Chat"
                >
                    <FiRotateCcw className="w-4 h-4" />
                </button>
                <button
                    onClick={toggleLanguage}
                    className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-all"
                    title={language === 'en' ? "Change to Tamil" : "Change to English"}
                >
                    <FiGlobe className="w-4 h-4" />
                </button>
                <button
                    onClick={onClose}
                    className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-all"
                    title="Close"
                >
                    <FiX className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
};

export default ChatHeader;
